import { Component, h } from "@lukekaalim/act";
import { TheatreState, ToolBelt } from "../../hooks";

import classes from './ToolbeltRenderer.module.css';
import { html } from "@lukekaalim/act-web";
import { ToolSlotRenderer } from "./ToolSlotRenderer";
import { useLogger } from "@kosmod/kit";
import { ListDropTarget } from "../TheatreOverlay/ListDropTarget";
import { ToolState } from "../../defs";

export type ToolbeltRendererProps = {
  state: TheatreState,
};


export const ToolbeltRenderer: Component<ToolbeltRendererProps> = ({ state }) => {
  const activeToolBelt = state.tools.toolbelts.find(t => t.id === state.tools.activeToolBelt);

  const logger = useLogger(`ToolbeltRenderer(${activeToolBelt && activeToolBelt.name})`);
  
  return h(html.div, { className: classes.container }, [
    h(html.div, { className: classes.primaryToolList },
      h(ListDropTarget, {
        items: state.tools.primaryTools,
        itemSize: { x: 72 + 4, y: 72 },
        calcKey(item: ToolState) {
          return item.id;
        },
        renderItem(tool: ToolState) {
          const beltSlotIndex = state.tools.primaryTools.indexOf(tool);

          return h(ToolSlotRenderer, {
            key: tool.id,

            selected: tool.id === state.tools.activeTool,
            shortcutKey: null,
            tool,
            beltSlotIndex,
            state,
            draggable: state.viewMode === 'content-browser',
            onClick() {
              state.tools.setActiveTool(tool.id)
            },
            onDragStart(e) {
              if (state.viewMode !== 'content-browser')
                return;

              const dragData = e.dataTransfer;
              if (!dragData)
                return;
              dragData.setDragImage(state.selection.emptyDragImage, 0, 0);

              state.selection.startDrag(
                { type: 'tool', toolId: tool.id, toolState: tool },
                state.tools.activeToolBelt ? { type: 'toolbelt', toolbeltId: state.tools.activeToolBelt } : null
              )
            },
          })
        },
        renderGap() {
          return h(html.div, { style: {
            border: '4px dotted white',
            borderRadius: '24px',
            transform: 'scale(0.8)',
            width: '64px',
            height: '64px',
          } })
        },
        state,
        acceptDrag(subject, source) {
          if (!activeToolBelt)
            return false
          
          if (activeToolBelt.tools.length >= 9 && !(source.type === 'toolbelt' && source.toolbeltId === activeToolBelt.id))
            return false;
          
          return subject.type === 'tool';
        },
        findExistingIndex(subject, source) {
          if (subject.type === 'tool') {
            const index = state.tools.primaryTools.findIndex(tool => subject.toolId === tool.id);
            if (index !== -1)
              return index;
          }
          return null;
        },
        onDrop(subject, source, index, event) {
          if (subject.type !== 'tool')
            return;
          // ???
          if (!state.tools.activeToolBelt)
            return;

          if (source.type === 'toolbelt') {
            if (source.toolbeltId !== state.tools.activeToolBelt) {
              // delete from remove toolbelt
              const sourceToolbelt = state.tools.toolbelts.find(tb => tb.id === source.toolbeltId)!;

              state.tools.setToolbelt(source.toolbeltId, {
                tools: sourceToolbelt.tools.filter(t => t.id !== subject.toolId)
              });
            }
          }

          const nextTools = [...state.tools.primaryTools]
            .filter(t => t.id !== subject.toolId);
          nextTools.splice(index, 0, subject.toolState);

          state.tools.setToolbelt(state.tools.activeToolBelt, { tools: nextTools });
        },
        className: classes.toolList
      }),
    ),

    h(html.ol, { className: classes.toolbeltList }, state.tools.toolbelts.map(toolbelt => {
      const isActive = toolbelt.id === state.tools.activeToolBelt;
      return h(html.li, {
        classList: [classes.toolbeltListEntry, isActive && classes.active],
        style: { '--toolbelt-color': "#" + toolbelt.color.getHexString() }
      },
        h(html.button, {
          className: classes.toolbeltListEntryButton,
          onClick(event) {
            state.tools.setActiveToolBelt(toolbelt.id)
          },
        }, h(html.span, {}, toolbelt.name)))
    }))
  ]);
}

